import { useEffect, useRef } from "react";
import styles from "./InlineTitleEditor.module.scss";

const COUNTER_FROM = 200;

// Edit-in-place title field: Enter or blur saves, Escape cancels. The save /
// cancel decisions themselves live in the chat session hook.
const InlineTitleEditor = ({
  value,
  onChange,
  onCommit,
  onCancel,
  maxLength,
  className = "",
}) => {
  const inputRef = useRef(null);
  // Escape must not also fire the blur save that follows it
  const cancelledRef = useRef(false);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onCommit();
    } else if (e.key === "Escape") {
      e.preventDefault();
      cancelledRef.current = true;
      onCancel();
    }
  };

  return (
    <span className={`${styles.titleEditor} ${className}`}>
      <input
        ref={inputRef}
        className={styles.titleEditor__input}
        value={value}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => {
          if (!cancelledRef.current) onCommit();
        }}
        onClick={(e) => e.stopPropagation()}
        aria-label="Conversation title"
      />
      {value.length >= COUNTER_FROM && (
        <span className={styles.titleEditor__counter}>
          {value.length}/{maxLength}
        </span>
      )}
    </span>
  );
};

export default InlineTitleEditor;
